<div
  class="container container-fluid"
  style="
    padding-top:15px;
    padding-bottom: 15px;
  "
>
  <h1 style="font-size: 24px; padding: 0 15px">Forgot My Password</h1>
  <button
    (click)="close()"
    style="
      position: absolute;
      top: -18px;
      right: -18px;
      background-color: #fff;
      border: 1px solid #f4f4f4;
      border-radius: 100%;
      min-width: 36px;
      min-height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
    "
  >
    <i class="fas fa-times" style="font-size: 24px; color: red"></i>
  </button>
</div>

<div mat-dialog-content>
  <div class="container container-fluid"
    [formGroup]="forgotPasswordForm"
  >
    <div class="row">
      <div class="col-md-12">
        <p
          style="
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 300;
            text-align: left;
            line-height: 22px;
          "
        >
          Enter your registered email address. We'll send you an email to reset
          your password.
        </p>
      </div>
    </div>

    <div class="row">
      <div style="margin-top: 10px" class="col-12 col-lg-12">
        <p
          style="
            color: black;
            text-align: left;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 5px;
          "
        >
          Email
        </p>
        <input
          type="email"
          formControlName="email"
          [ngClass]="{
            'shippn-border-red':
              forgotPasswordForm.get('email').touched &&
              forgotPasswordForm.get('email').invalid
          }"
          placeholder="Email"
          class="form-control form-control-sm shippn-input"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" style="margin-top: 10px;">
        <ngx-recaptcha2
          #captchaElem
          [siteKey]="recaptchaCheckboxKey"
          [useGlobalDomain]="false"
          formControlName="forgotPassRecaptcha"
          (expire)="onCaptchaExpired()"
          (error)="onCaptchaExpired()"
          captchaId="signincaptcha"
        >
        </ngx-recaptcha2>
      </div>
    </div>
    <div class="row">
      <div style="margin-top: 10px" class="col-md-12">
        <button
          style="
            width: 100px;
            font-size: 16px;
            font-weight: normal;
            height: 38px;
          "
          (click)="forgotPassword()"
          class="btn shippn-from-to-area-go-btn"
        >
          Send
        </button>
      </div>
    </div>
  </div>
</div>
